// this file added (completely changed) for individual by Bearer Web Developer (the old of this component completely changed such as it is added)
import React, { useEffect } from "react";
import { Dialog } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../states/app-state";
import styles from './LoginPopup.module.scss'; // added by Bearer Web Developer
import LoginWithMobileNumber from "./loginWithMobileNumber";
import { SigninSituation } from "../../states/signinState";
import EnterTheCode from "./enterTheCode";
import PersonalDetailsForSignup from "./personalDetailsForSignup";
import CreateAccount from "./createAccount";
import DisabledClickLoading from "../../components/DisabledClickLoading";
import HearAboutBearer from "./hearAboutBearer"; // added by Bearer Web Developer

interface ILoginPopupProps { open: boolean }
const LoginPopup: React.FC<ILoginPopupProps> = observer(({ open }) => {

    const appState = useAppState();
    const signin = appState.signin;
    const sendingCodeProcess = signin?.situation === SigninSituation.EnterCodeForSignin || signin?.situation === SigninSituation.EnterCodeForSignup
        || signin?.situation === SigninSituation.CodeExpiredForSignin || signin?.situation === SigninSituation.CodeExpiredForSignup;

    const handleClose = () => {
        if (signin.situation === SigninSituation.Login) appState.login.setOpen(false);
        else if (signin.situation === SigninSituation.CreateAccount) signin.setSituation(SigninSituation.Login);
        else if (sendingCodeProcess || SigninSituation.ReadyForSignup) return;
    }

    // modified for individual by Bearer Web Developer start

    // added by Bearer Web Developer start (RecaptchaVerifier for sign in with phone number for individual)
    useEffect(() => {

        signin.setLoading(true);
        signin.renderRecaptchaVerifier().finally(() => {
            signin.setLoading(false);
        });

    }, []);
    // added by Bearer Web Developer end (RecaptchaVerifier for sign in with phone number for individual)

    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose} PaperProps={{ style: { borderRadius: "10px" } }}
            >
                <div className={styles.root}>
                    {
                        signin?.situation === SigninSituation.CreateAccount ? <CreateAccount /> :
                            sendingCodeProcess ? <EnterTheCode /> : signin?.situation === SigninSituation.ReadyForSignup ?
                                <PersonalDetailsForSignup />
                                : signin?.situation === SigninSituation.HearAboutBearer ? <HearAboutBearer />
                                    : <LoginWithMobileNumber />
                    }
                </div>
                {signin.loading && <DisabledClickLoading />}
            </Dialog>
        </>
    );
    // modified by Bearer Web Developer end
})
export default LoginPopup;
